// API service for communicating with the backend

import { OSCSettings, CameraInfo, CaptureStatus } from '../types';
import { authService } from './auth';

import { API_BASE_URL } from './apiConfig';
export { API_BASE_URL } from './apiConfig';

class ApiService {
  private getHeaders(): HeadersInit {
    const headers: HeadersInit = {
      'Content-Type': 'application/json',
    };

    const token = authService.getToken();
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    return headers;
  }

  async getStatus(): Promise<CaptureStatus> {
    const response = await fetch(`${API_BASE_URL}/api/status`, {
      headers: this.getHeaders(),
    });
    if (!response.ok) {
      throw new Error('Failed to get status');
    }
    return response.json();
  }

  async startCapture(): Promise<{ status: string; message: string }> {
    const response = await fetch(`${API_BASE_URL}/api/capture/control`, {
      method: 'POST',
      headers: this.getHeaders(),
      body: JSON.stringify({ action: 'start' }),
    });
    
    if (!response.ok) {
      throw new Error('Failed to start capture');
    }
    
    return response.json();
  }

  async stopCapture(): Promise<{ status: string; message: string }> {
    const response = await fetch(`${API_BASE_URL}/api/capture/control`, {
      method: 'POST',
      headers: this.getHeaders(),
      body: JSON.stringify({ action: 'stop' }),
    });
    
    if (!response.ok) {
      throw new Error('Failed to stop capture');
    }
    
    return response.json();
  }

  async updateOSCSettings(settings: OSCSettings): Promise<{ status: string; settings: OSCSettings }> {
    const response = await fetch(`${API_BASE_URL}/api/osc/settings`, {
      method: 'POST',
      headers: this.getHeaders(),
      body: JSON.stringify(settings),
    });
    
    if (!response.ok) {
      throw new Error('Failed to update OSC settings');
    }
    
    return response.json();
  }

  async getCameras(): Promise<{ cameras: CameraInfo[] }> {
    const response = await fetch(`${API_BASE_URL}/api/cameras`, {
      headers: this.getHeaders(),
    });
    if (!response.ok) {
      throw new Error('Failed to get cameras');
    }
    return response.json();
  }

  async selectCamera(cameraId: number): Promise<{ status: string; camera_id: number }> {
    const response = await fetch(`${API_BASE_URL}/api/camera/select/${cameraId}`, {
      method: 'POST',
      headers: this.getHeaders(),
    });
    
    if (!response.ok) {
      throw new Error('Failed to select camera');
    }
    
    return response.json();
  }
}

export const apiService = new ApiService();